/**
 * "Sticky" section navigation
 * 
 * @since 1.0.0
 * @package crunchy
 */
(function($) {
	$(document).ready(function() {

		// sanity check
		if ( ! $( 'body' ).hasClass( 'section-page' ) ) {
			return;
		}

		// get things
		var adminBar   = $( '#wpadminbar' );
		var header     = $( '[role="banner"]' );
		var preHeader  = $( 'section + [role="banner"]' ).prev();
		var menuToggle = $( '#menu-toggle', header );
		var nav        = $( '#section-menus' );
		var main       = $( '[role="main"]' );

		// case there's a banner pre-header
		if ( preHeader.length < 1 ) {
			preHeader = $( '.banner + [role="banner"]' ).prev();
		}

		// do we have a pre-header layout?
		// set its height.
		var preScroll = preHeader.length > 0 ? preHeader.outerHeight( true ) : 0;

		// bind the scroll checker
		$( window ).scroll( maybeDoSticky );


		/**
		 * Check section nav scroll
		 */
		function maybeDoSticky() {

			// get heights
			var scroll         = $( document ).scrollTop();
			var adminBarHeight = adminBar.outerHeight();
			var headerHeight   = header.outerHeight();
			var navHeight      = nav.outerHeight();

			// santity check - make sure there's a nav
			if ( navHeight < 1 ) {
				return;
			}


			// if scrolled past the header, fix the
			// section navigation
			if ( scroll >= ( headerHeight + preScroll ) ) {
				nav.addClass( 'fixed' );
				main.addClass( 'section-menu-fixed' );
			}

			// if scrolled back up
			if ( scroll >= 0 && scroll < ( navHeight + preScroll ) ) {
				nav.removeClass( 'fixed' );
				main.removeClass( 'section-menu-fixed' );
			}
		}
	}); // document.ready
})(jQuery);